import { UploadCloudIcon } from "lucide-react";
import { LoadingSpinner } from "../loading-spinner";
import { useUnloadWarning } from "@/hooks/useUnloadWarning";
import { useBackgroundVisitStatus } from "@/hooks/backgroundVisitUpload/useBackgroundVisitStatus";
import { t } from "i18next";

interface Props {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export const OpenBackgroundVisitUploadButton = (props: Props): JSX.Element => {
  const { isUploading, unfinishedCount } = useBackgroundVisitStatus();

  useUnloadWarning(
    unfinishedCount != 0,
    t("backgroundVisitUpload.closePageMessage")
  );

  return (
    <button
      aria-label={t("backgroundVisitUpload.openBackgroundUploadsPanel")}
      className="relative p-2 rounded-md hover:bg-muted hover:text-muted-foreground transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
      onClick={() => {
        props.onOpenChange(!props.isOpen);
      }}
    >
      <UploadCloudIcon className="w-7 h-7 text-primary" />
      {unfinishedCount != 0 && (
        <span className="absolute -top-0 right-0 bg-error text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
          {isUploading ? (
            <LoadingSpinner className="w-3 h-3" />
          ) : (
            <>{unfinishedCount}</>
          )}
        </span>
      )}
    </button>
  );
};
